/** Mirrors backend `ScheduledCallOfferEndOutcome`; `NotOwned` never reaches the client, it becomes a business error. */
export enum ScheduledCallOfferEndOutcome {
  Ended = 1,
  AlreadyEnded = 2,
  Started = 3,
  NotExpired = 4,
  NotOwned = 5,
}
